// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"da7ef8f9","839":"d0a3fbfa"}[chunkId] + ".chunk.js";
};